import React, { useState } from 'react';
import useToggle from '../../hooks/useToggle';
import getNodes from './utils/getNodes';
import handleKeyboardEvent from './utils/hadnleKeyboardEvent';
import useActiveIndexSync from './utils/useActiveIndexSync';
import useNavGroupStyles from './utils/useNavGroupStyles';
const NavGroup = ({ children, id, shouldFocusOnMount = false, margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginRight, marginLeft, styles, ...rest }) => {
    const [isFocused, setFoucs, setBlur] = useToggle();
    const childrenArray = React.Children.toArray(children);
    const nodes = getNodes(id);
    const [activeIndex, setActiveIndex] = useState(0);
    const handleKeyDown = handleKeyboardEvent({ nodes, activeIndex, isFocused, setActiveIndex });
    const { wrapperStyles, itemStyles } = useNavGroupStyles({
        isFocused,
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginBottom,
        marginRight,
        marginLeft,
        styles
    });
    useActiveIndexSync({ id, activeIndex, setActiveIndex, isFocused });
    return (React.createElement("nav", { role: "navigation" },
        React.createElement("div", { role: "presentation", id: id, onFocus: setFoucs, onBlur: setBlur, onKeyDown: handleKeyDown },
            React.createElement("ul", { style: wrapperStyles, ...rest }, childrenArray.map((child, i) => (React.createElement("li", { key: i, id: `${id}-${i}`, style: childrenArray.length - 1 > i ? itemStyles : undefined }, child)))))));
};
export default NavGroup;
//# sourceMappingURL=NavGroup.js.map